var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"situacao-familiar","rota-base":"/admin/situacao-familiar","titulo-singular":"Situação Familiar","campos-extras":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }